//
//
//
//
//

export default {
  props:{
    text:String,
    validateBack:{
      type:Function,
      default:function(){
        return true
      }
    }
  },
  data(){
    return{
      loading:false
    }
  },
  methods:{
    sumbit(){
      if(!this.loading){
        if(this.validateBack()){
          this.loading = true
          this.$emit('notice-submit')
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/submitButton/index.vue